import { render, staticRenderFns } from "./CabinMonitoring.vue?vue&type=template&id=244c1e18&scoped=true&"
import script from "./CabinMonitoring.vue?vue&type=script&lang=js&"
export * from "./CabinMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244c1e18",
  null
  
)

export default component.exports